import React from "react";
import keyDropoffImg from "../../../../assets/images/keyless-return/key-dropoff.svg";

export function KeyDropoff({t}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <img
        src={keyDropoffImg}
        alt="Key Dropoff"
        className="return-image"
      />

      <p className="return-subtitle">
        {t("keylessReturnKeyInstruction")}
      </p>
    </div>
  );
}
